// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Paper,
//   Grid,
//   Button,
//   Chip,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Fade,
//   Stack,
//   Divider,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Inventory2,
//   CalendarToday,
//   Schedule,
//   LocationOn,
//   Business,
//   Message,
//   AccessTime,
//   Visibility,
//   Close,
//   Event,
//   Place,
//   CorporateFare,
//   Description,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import useAxios from "../useAxios";

// const MyOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const navigate = useNavigate();
//   const axiosData = useAxios();

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const storedAuth = localStorage.getItem("auth");
//         if (storedAuth) {
//           const { email } = JSON.parse(storedAuth);
//           const res = await axiosData.get(`getBookingData/${email}`);
//           setOrders(res.data?.bookings ? [res.data.bookings] : []);
//         }
//       } catch (err) {
//         console.error("Error loading orders:", err);
//       }
//     };
//     fetchOrders();
//   }, []);

//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setDialogOpen(true);
//   };

//   const handleCloseDialog = () => {
//     setDialogOpen(false);
//     setSelectedOrder(null);
//   };

//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "confirmed":
//         return { bg: "#ffebee", color: "#c62828", label: "Confirmed" };
//       case "cancelled":
//         return { bg: "#f5f5f5", color: "#757575", label: "Cancelled" };
//       case "completed":
//         return { bg: "#e8f5e8", color: "#2e7d32", label: "Completed" };
//       default:
//         return { bg: "#fff3e0", color: "#ef6c00", label: "Pending" };
//     }
//   };

//   return (
//     <Box
//       sx={{
//         p: { xs: 2, sm: 3 },
//         maxWidth: 1200,
//         margin: "0 auto",
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #fef7f7 0%, #fce4e4 100%)",
//       }}
//     >
//       {/* Header */}
//       <Box sx={{ display: "flex", alignItems: "center", mb: 4 }}>
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate("/user-dashboard")}
//           sx={{
//             color: "text.primary",
//             marginRight: 3,
//             borderRadius: "12px",
//             px: 3,
//             py: 1,
//             background: "white",
//             boxShadow: "0 2px 12px rgba(198, 40, 40, 0.1)",
//             border: "1px solid",
//             borderColor: "#ffcdd2",
//             "&:hover": {
//               backgroundColor: "#ffebee",
//               transform: "translateY(-2px)",
//               boxShadow: "0 4px 16px rgba(198, 40, 40, 0.15)",
//             },
//             transition: "all 0.3s ease",
//           }}
//         >
//           Back
//         </Button>

//         <Box>
//           <Typography
//             variant="h4"
//             sx={{
//               fontWeight: "800",
//               background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//               backgroundClip: "text",
//               WebkitTextFillColor: "transparent",
//             }}
//           >
//             My Orders
//           </Typography>
//           <Typography variant="body1" color="#d32f2f" sx={{ opacity: 0.8 }}>
//             Track your event bookings
//           </Typography>
//         </Box>
//       </Box>

//       {orders?.length === 0 ? (
//         <Fade in timeout={800}>
//           <Paper
//             sx={{
//               p: 6,
//               textAlign: "center",
//               borderRadius: 3,
//               background: "white",
//               boxShadow: "0 8px 32px rgba(211, 47, 47, 0.1)",
//               border: "2px dashed",
//               borderColor: "#ffcdd2",
//               maxWidth: 400,
//               margin: "4rem auto",
//             }}
//           >
//             <Box
//               sx={{
//                 width: 80,
//                 height: 80,
//                 borderRadius: "50%",
//                 background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 margin: "0 auto 2rem",
//               }}
//             >
//               <Inventory2 sx={{ fontSize: 40, color: "white" }} />
//             </Box>
//             <Typography variant="h6" color="#b71c1c" gutterBottom fontWeight="600">
//               No Orders Yet
//             </Typography>
//             <Typography variant="body2" color="#d32f2f" sx={{ mb: 3, opacity: 0.8 }}>
//               Start planning your amazing event today!
//             </Typography>
//             <Button
//               variant="contained"
//               sx={{
//                 borderRadius: 3,
//                 px: 4,
//                 py: 1.5,
//                 background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                 fontWeight: 600,
//                 "&:hover": {
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 20px rgba(211, 47, 47, 0.3)",
//                 },
//                 transition: "all 0.3s ease",
//               }}
//               onClick={() => navigate("/user-dashboard")}
//             >
//               Book Your First Event
//             </Button>
//           </Paper>
//         </Fade>
//       ) : (
//         <Grid container spacing={3}>
//           {orders.map((order, index) => {
//             const status = getStatusColor(order.status);
//             return (
//               <Grid item xs={12} key={index}>
//                 <Fade in timeout={500 + index * 100}>
//                   <Card
//                     sx={{
//                       borderRadius: 3,
//                       background: "white",
//                       boxShadow: "0 4px 20px rgba(211, 47, 47, 0.08)",
//                       border: "1px solid",
//                       borderColor: "#ffebee",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-4px)",
//                         boxShadow: "0 8px 32px rgba(211, 47, 47, 0.15)",
//                         borderColor: "#ffcdd2",
//                       },
//                     }}
//                   >
//                     <CardContent sx={{ p: 3 }}>
//                       {/* Header Row */}
//                       <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 3 }}>
//                         <Box>
//                           <Typography variant="h6" fontWeight="700" color="#b71c1c">
//                             Order #{index + 1}
//                           </Typography>
//                           <Typography variant="caption" color="#d32f2f" sx={{ opacity: 0.8 }}>
//                             Created: {new Date(order.createdAt).toLocaleDateString()}
//                           </Typography>
//                         </Box>
//                         <Box>
//                               <Box sx={{ display: "flex", flexDirection: "column", gap: 1, height: "100%", justifyContent: "center" }}>
//                             <Button
//                               variant="contained"

//                               onClick={() => handleViewDetails(order)}
//                               sx={{
//                                 borderRadius: 2,
//                                // py: 1,
//                                 background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                 fontWeight: 800,
//                                 fontSize: "0.8rem",
//                                 "&:hover": {
//                                   transform: "translateY(-2px)",
//                                   boxShadow: "0 6px 20px rgba(211, 47, 47, 0.3)",
//                                 },
//                                 transition: "all 0.3s ease",
//                               }}
//                             >
//                               View Full Details
//                             </Button>
//                             {/* <Typography variant="caption" color="#d32f2f" textAlign="center" sx={{ opacity: 0.8 }}>
//                               Click to see complete order information
//                             </Typography> */}
//                           </Box>
//                           {/* <Chip
//                             label={status.label}
//                             sx={{
//                               backgroundColor: status.bg,
//                               color: status.color,
//                               fontWeight: 700,
//                               borderRadius: 2,
//                               border: `1px solid ${status.color}20`,
//                             }}
//                           />
//                           <IconButton
//                             onClick={() => handleViewDetails(order)}
//                             sx={{
//                               background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                               color: "white",
//                               "&:hover": {
//                                 transform: "scale(1.1)",
//                                 background: "linear-gradient(45deg, #c62828 0%, #9c1c1c 100%)",
//                               },
//                               transition: "all 0.2s ease",
//                             }}
//                           >
//                             <Visibility />
//                           </IconButton> */}
//                         </Box>
//                       </Box>

//                       {/* Essential Information Grid */}
//                       <Grid container spacing={4}>
//                         {/* Event Details */}
//                         <Grid item xs={12} md={3}>
//                           <Stack spacing={2}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   p: 1,
//                                   borderRadius: 2,
//                                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <CalendarToday sx={{ color: "white", fontSize: 20 }} />
//                               </Box>
//                               <Box>
//                                 <Typography variant="caption" color="#d32f2f" fontWeight="600">
//                                   EVENT DATE
//                                 </Typography>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {order.eventDate}
//                                 </Typography>
//                               </Box>
//                             </Box>

//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   p: 1,
//                                   borderRadius: 2,
//                                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <Schedule sx={{ color: "white", fontSize: 20 }} />
//                               </Box>
//                               <Box>
//                                 <Typography variant="caption" color="#d32f2f" fontWeight="600">
//                                   EVENT TIME
//                                 </Typography>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {order.eventTime}
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           </Stack>
//                         </Grid>

//                         {/* Company & Location */}
//                         <Grid item xs={12} md={3}>
//                           <Stack spacing={2}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   p: 1,
//                                   borderRadius: 2,
//                                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <Business sx={{ color: "white", fontSize: 20 }} />
//                               </Box>
//                               <Box>
//                                 <Typography variant="caption" color="#d32f2f" fontWeight="600">
//                                   COMPANY
//                                 </Typography>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {order.companyName}
//                                 </Typography>
//                               </Box>
//                             </Box>

//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   p: 1,
//                                   borderRadius: 2,
//                                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <LocationOn sx={{ color: "white", fontSize: 20 }} />
//                               </Box>
//                               <Box>
//                                 <Typography variant="caption" color="#d32f2f" fontWeight="600">
//                                   LOCATION
//                                 </Typography>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {order.eventLocation}
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           </Stack>
//                         </Grid>

//                         {/* Additional Info */}
//                         <Grid item xs={12} md={3}>
//                           <Stack spacing={2}>
//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   p: 1,
//                                   borderRadius: 2,
//                                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <Inventory2 sx={{ color: "white", fontSize: 20 }} />
//                               </Box>
//                               <Box>
//                                 <Typography variant="caption" color="#d32f2f" fontWeight="600">
//                                   TOTAL ITEMS
//                                 </Typography>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {order.totalItems} Items
//                                 </Typography>
//                               </Box>
//                             </Box>

//                             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                               <Box
//                                 sx={{
//                                   p: 1,
//                                   borderRadius: 2,
//                                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                 }}
//                               >
//                                 <AccessTime sx={{ color: "white", fontSize: 20 }} />
//                               </Box>
//                               <Box>
//                                 <Typography variant="caption" color="#d32f2f" fontWeight="600">
//                                   REPORTING TIME
//                                 </Typography>
//                                 <Typography variant="body2" fontWeight="600">
//                                   {order.reportingTime}
//                                 </Typography>
//                               </Box>
//                             </Box>
//                           </Stack>
//                         </Grid>

//                         {/* Action Section */}
//                         {/* <Grid item xs={12} md={3}>
//                           <Box sx={{ display: "flex", flexDirection: "column", gap: 2, height: "100%", justifyContent: "center" }}>
//                             <Button
//                               variant="contained"
//                               fullWidth
//                               onClick={() => handleViewDetails(order)}
//                               sx={{
//                                 borderRadius: 2,
//                                 py: 1.5,
//                                 background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                                 fontWeight: 700,
//                                 fontSize: "0.9rem",
//                                 "&:hover": {
//                                   transform: "translateY(-2px)",
//                                   boxShadow: "0 6px 20px rgba(211, 47, 47, 0.3)",
//                                 },
//                                 transition: "all 0.3s ease",
//                               }}
//                             >
//                               View Full Details
//                             </Button>
//                             <Typography variant="caption" color="#d32f2f" textAlign="center" sx={{ opacity: 0.8 }}>
//                               Click to see complete order information
//                             </Typography>
//                           </Box>
//                         </Grid> */}
//                       </Grid>
//                     </CardContent>
//                   </Card>
//                 </Fade>
//               </Grid>
//             );
//           })}
//         </Grid>
//       )}

//       {/* Modern Red Theme Dialog */}
//       <Dialog
//         open={dialogOpen}
//         onClose={handleCloseDialog}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 4,
//             background: "white",
//             boxShadow: "0 24px 48px rgba(183, 28, 28, 0.15)",
//             overflow: "hidden",
//           },
//         }}
//       >
//         {selectedOrder && (
//           <>
//             {/* Dialog Header */}
//             <DialogTitle sx={{
//               p: 0,
//               background: "linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)",
//               color: "white",
//             }}>
//               <Box sx={{ p: 3, pb: 2 }}>
//                 <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
//                   <Box>
//                     <Typography variant="h5" fontWeight="800" gutterBottom>
//                       Order Details
//                     </Typography>
//                     <Typography variant="body1" sx={{ opacity: 0.9 }}>
//                       Complete booking information
//                     </Typography>
//                   </Box>
//                   <IconButton
//                     onClick={handleCloseDialog}
//                     sx={{
//                       color: "white",
//                       background: "rgba(255,255,255,0.2)",
//                       "&:hover": {
//                         background: "rgba(255,255,255,0.3)",
//                       }
//                     }}
//                   >
//                     <Close />
//                   </IconButton>
//                 </Box>
//                 <Chip
//                   label={getStatusColor(selectedOrder.status).label}
//                   sx={{
//                     background: "rgba(255,255,255,0.2)",
//                     color: "white",
//                     fontWeight: 700,
//                     border: "1px solid rgba(255,255,255,0.3)",
//                   }}
//                 />
//               </Box>
//             </DialogTitle>

//             <DialogContent sx={{ p: 0 }}>
//               <Stack spacing={0}>
//                 {/* Event Information Section */}
//                 <Box sx={{ p: 3 }}>
//                   <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Event />
//                     Event Information
//                   </Typography>
//                   <Grid container spacing={3}>
//                     <Grid item xs={12} sm={6}>
//                       <Stack spacing={2}>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             EVENT DATE
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.eventDate}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             EVENT TIME
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.eventTime}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             REPORTING TIME
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.reportingTime}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Stack spacing={2}>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             COMPANY
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.companyName}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             ACTIVITY TYPE
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.activityType}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             ACTIVITY AREA
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.activityArea}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Divider />

//                 {/* Location Details */}
//                 <Box sx={{ p: 3 }}>
//                   <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Place />
//                     Location Details
//                   </Typography>
//                   <Grid container spacing={3}>
//                     <Grid item xs={12} sm={6}>
//                       <Box>
//                         <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                           EVENT LOCATION
//                         </Typography>
//                         <Typography variant="body1" fontWeight="600">
//                           {selectedOrder.eventLocation}
//                         </Typography>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Box>
//                         <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                           EVENT CITY
//                         </Typography>
//                         <Typography variant="body1" fontWeight="600">
//                           {selectedOrder.event_city}
//                         </Typography>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Divider />

//                 {/* Booked Items */}
//                 <Box sx={{ p: 3 }}>
//                   <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Inventory2 />
//                     Booked Items ({selectedOrder.totalItems})
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {selectedOrder.items.map((item, i) => (
//                       <Grid item xs={12} sm={6} key={i}>
//                         <Box
//                           sx={{
//                             p: 2,
//                             borderRadius: 2,
//                             background: "#fff5f5",
//                             border: "1px solid",
//                             borderColor: "#ffcdd2",
//                           }}
//                         >
//                           <Typography variant="body1" fontWeight="700" color="#b71c1c" gutterBottom>
//                             {item.product}
//                           </Typography>
//                           <Typography variant="body2" color="#d32f2f" fontWeight="600">
//                             Quantity: {item.quantity}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* Message */}
//                 {selectedOrder.message && (
//                   <>
//                     <Divider />
//                     <Box sx={{ p: 3 }}>
//                       <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <Message />
//                         Additional Message
//                       </Typography>
//                       <Box
//                         sx={{
//                           p: 2,
//                           borderRadius: 2,
//                           background: "#fff5f5",
//                           border: "1px solid",
//                           borderColor: "#ffcdd2",
//                         }}
//                       >
//                         <Typography variant="body1">
//                           {selectedOrder.message}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </>
//                 )}
//               </Stack>
//             </DialogContent>

//             <DialogActions sx={{ p: 3, background: "#fafafa" }}>
//               <Button
//                 onClick={handleCloseDialog}
//                 variant="contained"
//                 fullWidth
//                 sx={{
//                   borderRadius: 2,
//                   py: 1.5,
//                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                   fontWeight: 700,
//                   fontSize: "1rem",
//                   "&:hover": {
//                     transform: "translateY(-2px)",
//                     boxShadow: "0 6px 20px rgba(211, 47, 47, 0.3)",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 Close Details
//               </Button>
//             </DialogActions>
//           </>
//         )}
//       </Dialog>
//     </Box>
//   );
// };

// export default MyOrders;

// import React, { useEffect, useState } from "react";
// import "./MyOrders.css";
// import {
//   Box,
//   Typography,
//   Paper,
//   Grid,
//   Button,
//   Chip,
//   Card,
//   CardContent,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Fade,
//   Stack,
//   Divider,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Inventory2,
//   CalendarToday,
//   Schedule,
//   LocationOn,
//   Business,
//   Message,
//   AccessTime,
//   Visibility,
//   Close,
//   Event,
//   Place,
//   CorporateFare,
//   Description,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import useAxios from "../useAxios";
// const EventCard = ({ image, activityType, description, eventTime }) => {
//   const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0 });
// useEffect(() => {
//   const timer = setInterval(() => {
//     if (!eventTime) return;

//     // Split by " to "
//     const [startStr, endStr] = eventTime.split(" to ").map(str => str.trim());
//     if (!endStr) return;

//     const now = new Date();
//     let endDateTime;

//     // ?? CASE 1: Format includes full date and time (e.g. "2025-11-09 10:00 AM to 2025-11-09 12:00 PM")
//     if (/\d{4}-\d{2}-\d{2}/.test(endStr)) {
//       endDateTime = new Date(endStr);

//     // ?? CASE 2: Date included only in start part (e.g. "2025-11-09 10:00 AM to 12:00 PM")
//     } else if (/\d{4}-\d{2}-\d{2}/.test(startStr)) {
//       const eventDate = startStr.split(" ")[0]; // extract "2025-11-09"
//       endDateTime = new Date(`${eventDate} ${endStr}`);

//     // ??? CASE 3: No date ? assume today (e.g. "10:00 AM to 12:00 PM")
//     } else {
//       const today = now.toISOString().split("T")[0]; // YYYY-MM-DD
//       endDateTime = new Date(`${today} ${endStr}`);
//     }

//     // Calculate remaining time
//     const distance = endDateTime.getTime() - now.getTime();

//     if (distance > 0) {
//       const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((distance % (1000 * 60)) / 1000);
//       setTimeLeft({ hours, minutes, seconds });
//     } else {
//       clearInterval(timer);
//       setTimeLeft({ hours: 0, minutes: 0, seconds: 0 });
//     }
//   }, 1000);

//   return () => clearInterval(timer);
// }, [eventTime]);
//   return (
//     <div className="event-card" >
//       <img src={image} alt={activityType} className="event-image" />
//       <div className="event-content">
//         <h3 className="event-title">{activityType}</h3>
//         {/* <p className="event-description">{description}</p> */}

//         <div className="remaining-box">
//           <p className="remaining-title">Remaining times</p>
//           <div className="time-row">
//             <div>
//               <h4>{String(timeLeft.hours).padStart(2, "0")}</h4>
//               <p>Hours</p>
//             </div>
//             <div>
//               <h4>{String(timeLeft.minutes).padStart(2, "0")}</h4>
//               <p>Minutes</p>
//             </div>
//             <div>
//               <h4>{String(timeLeft.seconds).padStart(2, "0")}</h4>
//               <p>Seconds</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
// const MyOrders = () => {
//   const events = [
//     {
//       image:
//         "https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?auto=format&fit=crop&w=800&q=60",
//       title: "Music Event",
//       description:
//         "Experience an unforgettable night with Coldplay, featuring their biggest hits and a mesmerizing light show!",
//       endTime: new Date().getTime() + 8 * 60 * 60 * 1000,
//     },
//     {
//       image:
//         "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?auto=format&fit=crop&w=800&q=60",
//       title: "Music Event",
//       description:
//         "Experience an unforgettable night with Coldplay, featuring their biggest hits and a mesmerizing light show!",
//       endTime: new Date().getTime() + 8 * 60 * 60 * 1000,
//     },
//     {
//       image:
//         "https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?auto=format&fit=crop&w=800&q=60",
//       title: "Music Event",
//       description:
//         "Experience an unforgettable night with Coldplay, featuring their biggest hits and a mesmerizing light show!",
//       endTime: new Date().getTime() + 8 * 60 * 60 * 1000,
//     },
//   ];
//   const [orders, setOrders] = useState([]);
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const navigate = useNavigate();
//   const axiosData = useAxios();
//     useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const storedAuth = localStorage.getItem("auth");
//         if (storedAuth) {
//           const { email } = JSON.parse(storedAuth);
//           const res = await axiosData.get(`getBookingData/${email}`);
//           setOrders(res.data?.bookings ? [res.data.bookings] : []);
//         }
//       } catch (err) {
//         console.error("Error loading orders:", err);
//       }
//     };
//     fetchOrders();
//   }, []);

//   const handleViewDetails = (order) => {
//     setSelectedOrder(order);
//     setDialogOpen(true);
//   };

//   const handleCloseDialog = () => {
//     setDialogOpen(false);
//     setSelectedOrder(null);
//   };
//   const getStatusColor = (status) => {
//     switch (status?.toLowerCase()) {
//       case "confirmed":
//         return { bg: "#ffebee", color: "#c62828", label: "Confirmed" };
//       case "cancelled":
//         return { bg: "#f5f5f5", color: "#757575", label: "Cancelled" };
//       case "completed":
//         return { bg: "#e8f5e8", color: "#2e7d32", label: "Completed" };
//       default:
//         return { bg: "#fff3e0", color: "#ef6c00", label: "Pending" };
//     }
//   };
//   return (
//     <div className="events-section">
//       <h1 className="section-title">Your Booking Products</h1>

//       <div className="filter-buttons">
//         <button className="active">Today</button>
//         <button>Tomorrow</button>
//         <button>This weekend</button>
//       </div>
//   {orders?.length === 0 ? (
//         <Fade in timeout={800}>
//           <Paper
//             sx={{
//               p: 6,
//               textAlign: "center",
//               borderRadius: 3,
//               background: "white",
//               boxShadow: "0 8px 32px rgba(211, 47, 47, 0.1)",
//               border: "2px dashed",
//               borderColor: "#ffcdd2",
//               maxWidth: 400,
//               margin: "4rem auto",
//             }}
//           >
//             <Box
//               sx={{
//                 width: 80,
//                 height: 80,
//                 borderRadius: "50%",
//                 background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 margin: "0 auto 2rem",
//               }}
//             >
//               <Inventory2 sx={{ fontSize: 40, color: "white" }} />
//             </Box>
//             <Typography variant="h6" color="#b71c1c" gutterBottom fontWeight="600">
//               No Orders Yet
//             </Typography>
//             <Typography variant="body2" color="#d32f2f" sx={{ mb: 3, opacity: 0.8 }}>
//               Start planning your amazing event today!
//             </Typography>
//             <Button
//               variant="contained"
//               sx={{
//                 borderRadius: 3,
//                 px: 4,
//                 py: 1.5,
//                 background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                 fontWeight: 600,
//                 "&:hover": {
//                   transform: "translateY(-2px)",
//                   boxShadow: "0 8px 20px rgba(211, 47, 47, 0.3)",
//                 },
//                 transition: "all 0.3s ease",
//               }}
//               onClick={() => navigate("/user-dashboard")}
//             >
//               Book Your First Event
//             </Button>
//           </Paper>
//         </Fade>
//       ) : (
//       <div className="events-grid">
//         {orders.map((event, index) => (
//           <EventCard key={index} {...event} />
//         ))}
//       </div>
//   )}
//   {/* Modern Red Theme Dialog */}
//        <Dialog
//         open={dialogOpen}
//         onClose={handleCloseDialog}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 4,
//             background: "white",
//             boxShadow: "0 24px 48px rgba(183, 28, 28, 0.15)",
//             overflow: "hidden",
//           },
//         }}
//       >
//         {selectedOrder && (
//           <>
//             {/* Dialog Header */}
//             <DialogTitle sx={{
//               p: 0,
//               background: "linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)",
//               color: "white",
//             }}>
//               <Box sx={{ p: 3, pb: 2 }}>
//                 <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
//                   <Box>
//                     <Typography variant="h5" fontWeight="800" gutterBottom>
//                       Order Details
//                     </Typography>
//                     <Typography variant="body1" sx={{ opacity: 0.9 }}>
//                       Complete booking information
//                     </Typography>
//                   </Box>
//                   <IconButton
//                     onClick={handleCloseDialog}
//                     sx={{
//                       color: "white",
//                       background: "rgba(255,255,255,0.2)",
//                       "&:hover": {
//                         background: "rgba(255,255,255,0.3)",
//                       }
//                     }}
//                   >
//                     <Close />
//                   </IconButton>
//                 </Box>
//                 <Chip
//                   label={getStatusColor(selectedOrder.status).label}
//                   sx={{
//                     background: "rgba(255,255,255,0.2)",
//                     color: "white",
//                     fontWeight: 700,
//                     border: "1px solid rgba(255,255,255,0.3)",
//                   }}
//                 />
//               </Box>
//             </DialogTitle>

//             <DialogContent sx={{ p: 0 }}>
//               <Stack spacing={0}>
//                 {/* Event Information Section */}
//                 <Box sx={{ p: 3 }}>
//                   <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Event />
//                     Event Information
//                   </Typography>
//                   <Grid container spacing={3}>
//                     <Grid item xs={12} sm={6}>
//                       <Stack spacing={2}>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             EVENT DATE
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.eventDate}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             EVENT TIME
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.eventTime}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             REPORTING TIME
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.reportingTime}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Stack spacing={2}>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             COMPANY
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.companyName}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             ACTIVITY TYPE
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.activityType}
//                           </Typography>
//                         </Box>
//                         <Box>
//                           <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                             ACTIVITY AREA
//                           </Typography>
//                           <Typography variant="body1" fontWeight="600">
//                             {selectedOrder.activityArea}
//                           </Typography>
//                         </Box>
//                       </Stack>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Divider />

//                 {/* Location Details */}
//                 <Box sx={{ p: 3 }}>
//                   <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Place />
//                     Location Details
//                   </Typography>
//                   <Grid container spacing={3}>
//                     <Grid item xs={12} sm={6}>
//                       <Box>
//                         <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                           EVENT LOCATION
//                         </Typography>
//                         <Typography variant="body1" fontWeight="600">
//                           {selectedOrder.eventLocation}
//                         </Typography>
//                       </Box>
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <Box>
//                         <Typography variant="caption" fontWeight="600" color="#d32f2f">
//                           EVENT CITY
//                         </Typography>
//                         <Typography variant="body1" fontWeight="600">
//                           {selectedOrder.event_city}
//                         </Typography>
//                       </Box>
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Divider />

//                 {/* Booked Items */}
//                 <Box sx={{ p: 3 }}>
//                   <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
//                     <Inventory2 />
//                     Booked Items ({selectedOrder.totalItems})
//                   </Typography>
//                   <Grid container spacing={2}>
//                     {selectedOrder.items.map((item, i) => (
//                       <Grid item xs={12} sm={6} key={i}>
//                         <Box
//                           sx={{
//                             p: 2,
//                             borderRadius: 2,
//                             background: "#fff5f5",
//                             border: "1px solid",
//                             borderColor: "#ffcdd2",
//                           }}
//                         >
//                           <Typography variant="body1" fontWeight="700" color="#b71c1c" gutterBottom>
//                             {item.product}
//                           </Typography>
//                           <Typography variant="body2" color="#d32f2f" fontWeight="600">
//                             Quantity: {item.quantity}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>

//                 {/* Message */}
//                 {selectedOrder.message && (
//                   <>
//                     <Divider />
//                     <Box sx={{ p: 3 }}>
//                       <Typography variant="h6" fontWeight="700" color="#b71c1c" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <Message />
//                         Additional Message
//                       </Typography>
//                       <Box
//                         sx={{
//                           p: 2,
//                           borderRadius: 2,
//                           background: "#fff5f5",
//                           border: "1px solid",
//                           borderColor: "#ffcdd2",
//                         }}
//                       >
//                         <Typography variant="body1">
//                           {selectedOrder.message}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </>
//                 )}
//               </Stack>
//             </DialogContent>

//             <DialogActions sx={{ p: 3, background: "#fafafa" }}>
//               <Button
//                 onClick={handleCloseDialog}
//                 variant="contained"
//                 fullWidth
//                 sx={{
//                   borderRadius: 2,
//                   py: 1.5,
//                   background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
//                   fontWeight: 700,
//                   fontSize: "1rem",
//                   "&:hover": {
//                     transform: "translateY(-2px)",
//                     boxShadow: "0 6px 20px rgba(211, 47, 47, 0.3)",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 Close Details
//               </Button>
//             </DialogActions>
//           </>
//         )}
//       </Dialog>
//     </div>
//   );
// };

// export default MyOrders;

import React, { useEffect, useState } from "react";
import "./MyOrders.css";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Fade,
  Stack,
  Divider,
} from "@mui/material";
import {
  LocationOn,
  AccessTime,
  CalendarToday,
  Map,
  Receipt,
  CurrencyRupee,
} from "@mui/icons-material";
import {
  Inventory2,
  Close,
  Event,
  Place,
  Message,
  AccountCircle,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useAxios from "../useAxios";
import CircleIcon from '@mui/icons-material/Circle';
// InfoItem Component for consistent field display
const InfoItem = ({ label, value }) => (
  <Box sx={{ mb: 2.5 }}>
    <Typography
      variant="caption"
      color="#d32f2f"
      fontWeight="600"
      display="block"
      sx={{ mb: 0.5 }}
    >
      {label}
    </Typography>
    <Typography
      variant="body1"
      fontWeight="600"
      sx={{
        minHeight: "24px",
        display: "flex",
        alignItems: "center",
      }}
    >
      {value || "�"}
    </Typography>
  </Box>
);
// ProductCard Component for product items
const ProductCard = ({ item, index }) => (
  <Box
    sx={{
      p: 2.5,
      borderRadius: 2,
      background: "white",
      border: "1px solid #e0e0e0",
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      transition: "all 0.3s ease",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(211, 47, 47, 0.15)",
        borderColor: "#ffcdd2",
      },
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 2,
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="h6" fontWeight="600" color="#d32f2f" noWrap>
          {item.product || `Product ${index + 1}`}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Quantity: {item.quantity || 1}
        </Typography>
        {item.description && (
          <Typography variant="body2" sx={{ mt: 1, fontStyle: "italic" }}>
            {item.description}
          </Typography>
        )}
      </Box>

      {item.price && (
        <Typography
          variant="h6"
          fontWeight="700"
          color="#2e7d32"
          sx={{ flexShrink: 0 }}
        >
          <CurrencyRupee sx={{fontSize:"15px",textAlign:"center"}}/>{item.price}
        </Typography>
      )}
    </Box>

    {item.subItems && item.subItems.length > 0 && (
      <Box sx={{ mt: 2, pl: 2, borderLeft: "2px solid #ffcdd2" }}>
        <Typography variant="caption" fontWeight="600" color="#d32f2f">
          Includes:
        </Typography>
        <Stack spacing={1} sx={{ mt: 1 }}>
          {item.subItems.map((subItem, subIndex) => (
            <Box
              key={subIndex}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="body2" sx={{ flex: 1 }}>
                {subItem.name}
              </Typography>
              {subItem.price && (
                <Typography
                  variant="body2"
                  fontWeight="600"
                  sx={{ flexShrink: 0, ml: 2 }}
                >
                  <CurrencyRupee sx={{fontSize:"15px",textAlign:"center"}}/>{subItem.price}
                </Typography>
              )}
            </Box>
          ))}
        </Stack>
      </Box>
    )}
  </Box>
);
// PriceSummary Component
const PriceSummary = ({ selectedOrder }) => {
  const calculateTotal = () => {
    if (selectedOrder.totalAmount) return selectedOrder.totalAmount;

    if (selectedOrder.items) {
      return selectedOrder.items.reduce((total, item) => {
        return total + (item.price || 0) * (item.quantity || 1);
      }, 0);
    }

    return 0;
  };

  const calculateTax = (total) => total * 0.18;
  const subtotal = calculateTotal();
  const tax = calculateTax(subtotal);
  const grandTotal = subtotal + tax;

  return (
    <Stack spacing={2} sx={{ flex: 1 }}>
      {/* Price Breakdown */}
      <Box
        sx={{
          background: "white",
          p: 2.5,
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          flex: "0 0 auto",
        }}
      >
        <PriceRow label="Subtotal" value={subtotal} />
        <PriceRow label="GST (18%)" value={tax} />
        <Divider sx={{ my: 1.5 }} />
        <PriceRow label="Grand Total" value={grandTotal} isTotal />
      </Box>

      {/* Payment Status */}
      {/* <Box
        sx={{
          background: "white",
          p: 2.5,
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          flex: "0 0 auto",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="600"
          color="#b71c1c"
          gutterBottom
        >
          Payment Status
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <Chip
            label={selectedOrder.paymentStatus || "PAID"}
            color={
              selectedOrder.paymentStatus === "PENDING" ? "warning" : "success"
            }
            sx={{ fontWeight: 600 }}
          />
          {selectedOrder.paymentMethod && (
            <Typography variant="body2" color="text.secondary">
              Via {selectedOrder.paymentMethod}
            </Typography>
          )}
        </Box>
      </Box> */}

      {/* Booking Timeline */}
      <Box
        sx={{
          background: "white",
          p: 2.5,
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          flex: "0 0 auto",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight="600"
          color="#b71c1c"
          gutterBottom
        >
          Booking Timeline
        </Typography>
        <TimelineItem label="Booked On" value={selectedOrder.createdAt} />
        {/* <TimelineItem label="Last Updated" value={selectedOrder.updatedAt} /> */}
      </Box>
    </Stack>
  );
};
// Helper Components
const PriceRow = ({ label, value, isTotal = false }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      py: 0.5,
    }}
  >
    <Typography
      variant={isTotal ? "h6" : "body1"}
      fontWeight={isTotal ? 700 : 500}
      sx={{ flex: 1 }}
    >
      {label}
    </Typography>
    <Typography
      variant={isTotal ? "h5" : "body1"}
      fontWeight={700}
      color={isTotal ? "#d32f2f" : "text.primary"}
      sx={{
        flexShrink: 0,
        ml: 2,
        textAlign: "right",
        minWidth: "80px",
      }}
    >
      <CurrencyRupee sx={{fontSize:isTotal?"18px":"12px",textAlign:"center",fontWeight: "bold"}}/>{value.toFixed(2)}
    </Typography>
  </Box>
);
const TimelineItem = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      mt: 1.5,
    }}
  >
    <Typography variant="body2" color="text.secondary" sx={{ flex: 1 }}>
      {label}:
    </Typography>
    <Typography
      variant="body2"
      fontWeight="500"
      sx={{
        flexShrink: 0,
        ml: 2,
        textAlign: "right",
      }}
    >
      {value ? new Date(value).toLocaleDateString() : "�"}
    </Typography>
  </Box>
);
const EventCard = ({
  image,
  activityType,
  eventTime,
  eventDate,
  eventLocation,
  event_city,
}) => {
  const [timeLeft, setTimeLeft] = useState({
    status: "",
    hours: 0,
    minutes: 0,
    seconds: 0,
    text: "",
  });
  useEffect(() => {
    if (!eventDate || !eventTime) return;

    const timer = setInterval(() => {
      const now = new Date();

      // ? Handle both single dates and date ranges
      let startDateStr, endDateStr;
      if (eventDate.includes(" to ")) {
        // Date range format: "13/11/2025 to 14/11/2025"
        const [startStr, endStr] = eventDate.split(" to ");
        startDateStr = startStr; // "13/11/2025"
        endDateStr = endStr; // "14/11/2025"
      } else {
        // Single date format: "20/11/2025"
        startDateStr = eventDate;
        endDateStr = eventDate;
      }

      // ? Convert DD/MM/YYYY to Date objects
      const startDateParts = startDateStr.split("/");
      const endDateParts = endDateStr.split("/");

      const startDateObj = new Date(
        `${startDateParts[2]}-${startDateParts[1]}-${startDateParts[0]}`
      );
      const endDateObj = new Date(
        `${endDateParts[2]}-${endDateParts[1]}-${endDateParts[0]}`
      );

      // ? Split time range "6:00 PM to 9:00 PM"
      const [startTimeStr, endTimeStr] = eventTime
        .split(" to ")
        .map((str) => str.trim());
      if (!startTimeStr || !endTimeStr) return;

      // ? Function to parse time with AM/PM format
      const parseTimeWithDate = (dateStr, timeStr) => {
        const [day, month, year] = dateStr.split("/");

        // Parse time with AM/PM
        let [time, modifier] = timeStr.split(" ");
        let [hours, minutes] = time.split(":");

        hours = parseInt(hours);
        minutes = parseInt(minutes);

        // Convert to 24-hour format
        if (modifier === "PM" && hours !== 12) {
          hours += 12;
        } else if (modifier === "AM" && hours === 12) {
          hours = 0;
        }

        // Create date object with proper time
        return new Date(year, month - 1, day, hours, minutes, 0);
      };

      const startDateTime = parseTimeWithDate(startDateStr, startTimeStr);
      const endDateTime = parseTimeWithDate(endDateStr, endTimeStr);

      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      // ?? Case 1: Event has completely ended
      if (endDateTime < now) {
        setTimeLeft({ status: "closed", text: "Event Closed" });
        clearInterval(timer);
        return;
      }

      // ?? Case 2: Event is currently running
      if (startDateTime <= now && endDateTime > now) {
        const distance = endDateTime - now;
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setTimeLeft({
          status: "today",
          hours,
          minutes,
          seconds,
          isEventRunning: true,
        });
        return;
      }

      // ?? Case 3: Event starts in the future (today or later)
      if (startDateTime > now) {
        const distance = startDateTime - now;
        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Check if it starts today
        const startsToday =
          startDateObj.getDate() === today.getDate() &&
          startDateObj.getMonth() === today.getMonth() &&
          startDateObj.getFullYear() === today.getFullYear();

        if (startsToday) {
          setTimeLeft({
            status: "today",
            hours,
            minutes,
            seconds,
            isEventRunning: false,
          });
        } else if (
          startDateObj.getDate() === tomorrow.getDate() &&
          startDateObj.getMonth() === tomorrow.getMonth() &&
          startDateObj.getFullYear() === tomorrow.getFullYear()
        ) {
          setTimeLeft({ status: "upcoming", text: "Event is Tomorrow" });
        } else {
          const formattedDate = startDateObj.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
          setTimeLeft({ status: "future", text: `Event on ${formattedDate}` });
        }
        return;
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [eventDate, eventTime]);
  return (
    <div
      className={`event-card ${
        timeLeft.status === "today" ? "event-today-glow" : ""
      }`}
    >
      <div className="timing-chip-container">
        {timeLeft.status === "today" ? (
          <div className="countdown-chip">
            <span className="chip-label">
              {timeLeft.isEventRunning ? "Ends In" : "Starts In"}
            </span>
            <div className="chip-time">
              <span>{String(timeLeft.hours).padStart(2, "0")}</span>:
              <span>{String(timeLeft.minutes).padStart(2, "0")}</span>:
              <span>{String(timeLeft.seconds).padStart(2, "0")}</span>
            </div>
          </div>
        ) : (
          <div className={`status-chip ${timeLeft.status}`}>
            <span className="chip-text">
              {timeLeft?.text ? timeLeft?.text : "loading"}
            </span>
          </div>
        )}
      </div>
      <div className="event-date">
        {(() => {
          // Check if it's a date range or single date
          if (eventDate.includes(" to ")) {
            // Handle date range format "13/11/2025 to 14/11/2025"
            const [startDate, endDate] = eventDate.split(" to ");
            const startParts = startDate.split("/");
            const endParts = endDate.split("/");

            return (
              <>
                <span className="day-range">
                  {startParts[0]}-{endParts[0]}
                </span>
                <span className="month-year">
                  {new Date(
                    `${startParts[2]}-${startParts[1]}-${startParts[0]}`
                  ).toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                  })}
                </span>
              </>
            );
          } else {
            // Handle single date format "20/11/2025"
            const dateParts = eventDate.split("/");
            return (
              <>
                <span className="day">{dateParts[0]}</span>
                <span className="month-year">
                  {new Date(
                    `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
                  ).toLocaleDateString("en-US", {
                    month: "long",
                    year: "numeric",
                  })}
                </span>
              </>
            );
          }
        })()}
      </div>
      <div className="event-info">
        <h3 className="event-title">{activityType}</h3>
        <div className="event-sub-info">
          <span className="event-location">
            <LocationOn
              fontSize="small"
              sx={{ verticalAlign: "middle", color: "red", mr: 0.5 }}
            />
            {eventLocation} - {event_city}
          </span>
          <span className="event-time">
            <AccessTime
              fontSize="small"
              sx={{ verticalAlign: "middle", color: "red", mr: 0.5 }}
            />
            {eventTime}
          </span>
        </div>
      </div>
    </div>
  );
};

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const axiosData = useAxios();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const storedAuth = localStorage.getItem("auth");
        if (storedAuth) {
          const { email } = JSON.parse(storedAuth);
          const res = await axiosData.get(`getBookingData/${email}`);

          // ensure data structure is consistent
          if (Array.isArray(res.data?.bookings)) {
            setOrders(res.data.bookings);
          } else if (res.data?.bookings) {
            setOrders([res.data.bookings]);
          } else {
            setOrders([]);
          }
        }
      } catch (err) {
        console.error("Error loading orders:", err);
      }
    };
    fetchOrders();
  }, []);

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedOrder(null);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "confirmed":
        return { bg: "#ffebee", color: "#c62828", label: "Confirmed" };
      case "cancelled":
        return { bg: "#f5f5f5", color: "#757575", label: "Cancelled" };
      case "completed":
        return { bg: "#e8f5e8", color: "#2e7d32", label: "Completed" };
      default:
        return { bg: "#fff3e0", color: "#ef6c00", label: "Pending" };
    }
  };

  return (
    <div className="events-section">
      <h1 className="section-title">Your Booking Products</h1>

      {/* <div className="filter-buttons">
        <button className="active">Today</button>
        <button>Tomorrow</button>
        <button>This Weekend</button>
      </div> */}
      {orders?.length === 0 ? (
        <Fade in timeout={800}>
          <Paper
            sx={{
              p: 6,
              textAlign: "center",
              borderRadius: 3,
              background: "white",
              boxShadow: "0 8px 32px rgba(211, 47, 47, 0.1)",
              border: "2px dashed",
              borderColor: "#ffcdd2",
              maxWidth: 400,
              margin: "4rem auto",
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 2rem",
              }}
            >
              <Inventory2 sx={{ fontSize: 40, color: "white" }} />
            </Box>
            <Typography
              variant="h6"
              color="#b71c1c"
              gutterBottom
              fontWeight="600"
            >
              No Orders Yet
            </Typography>
            <Typography
              variant="body2"
              color="#d32f2f"
              sx={{ mb: 3, opacity: 0.8 }}
            >
              Start planning your amazing event today!
            </Typography>
            <Button
              variant="contained"
              sx={{
                borderRadius: 3,
                px: 4,
                py: 1.5,
                background: "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
                fontWeight: 600,
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 20px rgba(211, 47, 47, 0.3)",
                },
                transition: "all 0.3s ease",
              }}
              onClick={() => navigate("/user-dashboard")}
            >
              Book Your First Event
            </Button>
          </Paper>
        </Fade>
      ) : (
        <div className="events-grid">
          {orders.map((order, index) => (
            <div key={index} onClick={() => handleViewDetails(order)}>
              <EventCard
                image={order.image}
                activityType={order.activityType}
                eventTime={order.eventTime}
                eventDate={order.eventDate}
                eventLocation={order.eventLocation}
                event_city={order.event_city}
              />
            </div>
          ))}
        </div>
      )}

      {/* Details Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        maxWidth="md"
        PaperProps={{
          sx: {
            borderRadius: 3,
            background: "white",
            boxShadow: "0 24px 48px rgba(183, 28, 28, 0.15)",
            overflow: "hidden",
          },
        }}
      >
        {selectedOrder && (
          <>
            {/* Header */}
            <DialogTitle
              sx={{
                p: 0,
                background: "linear-gradient(135deg, #d32f2f 0%, #b71c1c 100%)",
                color: "white",
              }}
            >
              <Box sx={{ p: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 1,
                  }}
                >
                  <Box sx={{ flex: 1, mr: 2 }}>
                    <Typography variant="h5" fontWeight="800" gutterBottom>
                      Order Details
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      sx={{ opacity: 0.9, fontWeight: 500 }}
                    >
                      {selectedOrder.activityType} <CircleIcon sx={{ fontSize: "8px" }} /> {selectedOrder.companyName}
                    </Typography>
                  </Box>
                  <IconButton
                    onClick={handleCloseDialog}
                    sx={{
                      color: "white",
                      background: "rgba(255,255,255,0.2)",
                      "&:hover": {
                        background: "rgba(255,255,255,0.3)",
                      },
                      flexShrink: 0,
                      mt: -0.5,
                    }}
                  >
                    <Close />
                  </IconButton>
                </Box>
              </Box>
            </DialogTitle>

            {/* Content - Single Column */}
            <DialogContent sx={{ p: 0 }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {/* Event Information */}
                <Box sx={{ p: 3, pb: 2.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      mb: 2.5,
                    }}
                  >
                    <Event sx={{ fontSize: 24, color: "#b71c1c" }} />
                    <Typography variant="h6" fontWeight="700" color="#b71c1c">
                      Event Information
                    </Typography>
                  </Box>
                  <Grid container spacing={2.5}>
                    <Grid item xs={12} sm={6}>
                      <InfoItem
                        label="EVENT DATE"
                        value={selectedOrder.eventDate}
                      />
                      <InfoItem
                        label="EVENT TIME"
                        value={selectedOrder.eventTime}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InfoItem
                        label="REPORTING TIME"
                        value={selectedOrder.reportingTime}
                      />
                      <InfoItem
                        label="MULTI-DAY EVENT"
                        value={selectedOrder.isMultiDay ? "Yes" : "No"}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InfoItem
                        label="ACTIVITY TYPE"
                        value={selectedOrder.activityType}
                      />
                      <InfoItem
                        label="ACTIVITY AREA"
                        value={selectedOrder.activityArea}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InfoItem
                        label="COMPANY"
                        value={selectedOrder.companyName}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Divider />

                {/* Location Details in Single Row */}
                <Box sx={{ p: 3, py: 2.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      mb: 2.5,
                    }}
                  >
                    <Place sx={{ fontSize: 24, color: "#b71c1c" }} />
                    <Typography variant="h6" fontWeight="700" color="#b71c1c">
                      Location Details
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        flex: 1,
                      }}
                    >
                      <Place
                        sx={{ color: "#d32f2f", mt: 0.5, flexShrink: 0 }}
                      />
                      <Box>
                        <Typography
                          variant="subtitle1"
                          fontWeight="600"
                          gutterBottom
                        >
                          {selectedOrder.eventLocation || "Venue Location"}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {selectedOrder.event_city || "City not specified"}
                        </Typography>
                      </Box>
                    </Box>

                    {selectedOrder.venueMapLink && (
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<Map />}
                        sx={{
                          borderColor: "#d32f2f",
                          color: "#d32f2f",
                          "&:hover": {
                            borderColor: "#b71c1c",
                            background: "rgba(211, 47, 47, 0.04)",
                          },
                          flexShrink: 0,
                        }}
                        onClick={() =>
                          window.open(selectedOrder.venueMapLink, "_blank")
                        }
                      >
                        View on Map
                      </Button>
                    )}
                  </Box>
                </Box>

                <Divider />

                {/* Product Details */}
                <Box sx={{ p: 3, py: 2.5 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      mb: 2.5,
                    }}
                  >
                    <Inventory2 sx={{ fontSize: 24, color: "#b71c1c" }} />
                    <Typography variant="h6" fontWeight="700" color="#b71c1c">
                      Product Details
                    </Typography>
                  </Box>

                  {selectedOrder.items && selectedOrder.items.length > 0 ? (
                    <Stack spacing={2}>
                      {selectedOrder.items.map((item, index) => (
                        <ProductCard key={index} item={item} index={index} />
                      ))}

                      {/* Total Items */}
                      <Box
                        sx={{
                          mt: 2,
                          pt: 2,
                          borderTop: "2px dashed #e0e0e0",
                        }}
                      >
                        <Typography
                          variant="h6"
                          fontWeight="700"
                          color="#d32f2f"
                        >
                          Total Items:{" "}
                          {selectedOrder.totalItems ||
                            selectedOrder.items.length}
                        </Typography>
                      </Box>

                      {/* Price Summary below Total Items */}
                      <Box
                        sx={{
                          mt: 3,
                          p: 3,
                          borderRadius: 2,
                          background:
                            "linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            mb: 3,
                          }}
                        >
                          <Receipt sx={{ fontSize: 24, color: "#b71c1c" }} />
                          <Typography
                            variant="h6"
                            fontWeight="700"
                            color="#b71c1c"
                          >
                            Price Summary
                          </Typography>
                        </Box>
                        <PriceSummary selectedOrder={selectedOrder} />
                      </Box>
                    </Stack>
                  ) : (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                      <Typography
                        color="text.secondary"
                        sx={{ fontStyle: "italic" }}
                      >
                        No product details available
                      </Typography>
                    </Box>
                  )}
                </Box>

                {/* Additional Message */}
                {selectedOrder.message && (
                  <>
                    <Divider />
                    <Box sx={{ p: 3, py: 2.5 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5,
                          mb: 2,
                        }}
                      >
                        <Message sx={{ fontSize: 24, color: "#b71c1c" }} />
                        <Typography
                          variant="h6"
                          fontWeight="700"
                          color="#b71c1c"
                        >
                          Additional Message
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          background: "#fff5f5",
                          border: "1px solid #ffcdd2",
                          borderLeft: "4px solid #d32f2f",
                        }}
                      >
                        <Typography variant="body2" sx={{ lineHeight: 1.6 }}>
                          {selectedOrder.message}
                        </Typography>
                      </Box>
                    </Box>
                  </>
                )}
              </Box>
            </DialogContent>

            {/* Footer */}
            <DialogActions
              sx={{
                p: 2.5,
                background: "#fafafa",
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                onClick={handleCloseDialog}
                sx={{
                  borderRadius: 2,
                  py: 1,
                  px: 4,
                  background:
                    "linear-gradient(45deg, #d32f2f 0%, #b71c1c 100%)",
                  fontWeight: 700,
                  "&:hover": {
                    transform: "translateY(-1px)",
                    boxShadow: "0 4px 12px rgba(211, 47, 47, 0.3)",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
    </div>
  );
};

export default MyOrders;
